"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = void 0;

var _const = require("../../const");

var _styledComponents = require("styled-components");

var objektiv = {
  fontFamily: _const.FontFamilyValue.primary,
  fontFaces: [{
    local: "local('Objektiv Mk2 Light'), local('ObjektivMk2-Light')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.light, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.light, ".woff2) format('woff')"),
    fontWeight: 300,
    fontStyle: 'normal'
  }, {
    local: "local('Objektiv Mk2'), local('ObjektivMk2-Regular')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.regular, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.regular, ".woff2) format('woff')"),
    fontWeight: 400,
    fontStyle: 'normal'
  }, {
    local: "local('Objektiv Mk2 Medium'), local('ObjektivMk2-Medium')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.medium, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.medium, ".woff2) format('woff')"),
    fontWeight: 500,
    fontStyle: 'normal'
  }, {
    local: "local('Objektiv Mk2 Bold'), local('ObjektivMk2-Bold')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.bold, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontObjectiv.bold, ".woff2) format('woff')"),
    fontWeight: 700,
    fontStyle: 'normal'
  }]
};
var margo = {
  fontFamily: _const.FontFamilyValue.secondary,
  fontFaces: [{
    local: "local('Margo Script Regular'), local('MargoScript-Regular')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontMargo.regular, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontMargo.regular, ".woff2) format('woff')"),
    fontWeight: 400,
    fontStyle: 'normal'
  }]
};
var abscript = {
  fontFamily: _const.FontFamilyValue.tertiary,
  fontFaces: [{
    local: "local('ABScript Light'), local('ABScript-Light')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontABS.light, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontABS.light, ".woff2) format('woff')"),
    fontWeight: 300,
    fontStyle: 'normal'
  }, {
    local: "local('ABScript'), local('ABScript-Regular')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontABS.regular, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontABS.regular, ".woff2) format('woff')"),
    fontWeight: 400,
    fontStyle: 'normal'
  }, {
    local: "local('ABScript Bold'), local('ABScript-Bold')",
    primarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontABS.bold, ".woff) format('woff2')"),
    secondarySrc: "url(".concat(_const.assetsUrl, "/").concat(_const.fontABS.bold, ".woff2) format('woff')"),
    fontWeight: 700,
    fontStyle: 'normal'
  }]
};
var faces = [objektiv, margo, abscript];

var formatFontFace = function formatFontFace(fontFace, fontFamily) {
  return "\n    @font-face {\n        font-family: '".concat(fontFamily, "';\n        src: ").concat(fontFace.local, ", ").concat(fontFace.primarySrc, ", ").concat(fontFace.secondarySrc, ";\n        font-weight: ").concat(fontFace.fontWeight, ";\n        font-style: ").concat(fontFace.fontStyle, ";\n        font-display: swap;\n    }");
};

var formatFontFamily = function formatFontFamily(fontFamilyDetails) {
  return fontFamilyDetails.fontFaces.reduce(function (templateLiteral, face) {
    return templateLiteral + formatFontFace(face, fontFamilyDetails.fontFamily);
  }, '');
};

var fonts = /*#__PURE__*/(0, _styledComponents.css)(["", ""], function () {
  return faces.reduce(function (templateLiteral, fontFamilyDetails) {
    return templateLiteral + formatFontFamily(fontFamilyDetails);
  }, '');
});
exports.fonts = fonts;